'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BrandModelService = function () {
  function BrandModelService($http, appConfig) {
    "ngInject";

    (0, _classCallCheck3.default)(this, BrandModelService);
    this.$http = $http;
    this.appConfig = appConfig;
  }

  (0, _createClass3.default)(BrandModelService, [{
    key: 'listBrandModels',
    value: function listBrandModels(filterParams) {
      var query = '';

      query += '?pageStart=' + filterParams.pageCriteria.pageStart;
      query += '&itemsToFetch=' + filterParams.pageCriteria.itemsToFetch;
      query += '&sortExpression=' + filterParams.pageCriteria.sortExpression;
      query += '&ascending=' + filterParams.pageCriteria.ascending;

      if (filterParams.brandName) {
        query += '&brandName=' + filterParams.brandName;
      }

      if (filterParams.brandModelName) {
        query += '&brandModelName=' + filterParams.brandModelName;
      }

      return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/brandmodel/list' + query);
    }
  }]);
  return BrandModelService;
}();

exports.default = BrandModelService;


// WEBPACK FOOTER //
// ./client/app/components/admin/brandModelManagement/BrandModel.Service.js